import styled from "@emotion/styled";
import deepmerge from "deepmerge";
import { Description as FollowUsOnFacebookDescription } from "scmp-sdk/components/follow-us-on-facebook/styles";
import {
  Button as FindOutMoreButton,
  Container as FindOutMoreContainer,
  Message as FindOutMoreMessage,
} from "scmp-sdk/components/newsletter/newsletter-widget/find-out-more/styles";
import { StyledIconArrowPrevious } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  Container as SignUpNewsletterContainer,
  Title as SignUpNewsletterTitle,
  Summary,
  Title,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  SeeMoreLink,
  Container as SignUpSuccessMessageContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";
import {
  theme as ArticleTheme,
  Container as ArticleThemeContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/variants/article-theme/styles";

export const theme: ThemeType = deepmerge(ArticleTheme, {
  newsletterIcon: {
    icon: "white",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "white",
  },
});

export const Container = styled(ArticleThemeContainer)`
  ${SignUpSuccessMessageContainer} {
    color: #ffffff;

    ${SeeMoreLink}, ${FollowUsOnFacebookDescription} {
      color: #ffffff;
    }
  }

  ${FindOutMoreContainer} {
    ${FindOutMoreMessage}, ${FindOutMoreButton} {
      color: #ffffff;
    }
  }

  ${SignUpNewsletterContainer} {
    color: #ffffff;

    ${StyledIconArrowPrevious} {
      path {
        stroke: #ffffff;
      }
    }

    ${Title}, ${Summary} {
      color: #ffffff;
    }

    ${Title} path {
      fill: #ffffff;
    }

    ${SubmitButton} {
      background-color: #000000;
    }

    ${SignUpNewsletterTitle} {
      color: #ffffff;
    }

    ${SocialButtonIconContainer} {
      background-color: #000000;
    }
  }
`;
